import { Button, ChevronLeftIcon } from './ui';
import { useNavigateBack } from '../hooks/useNavigateBack';
import { t } from '../i18n';

export function BackButton({
  fallback,
  size = 'sm',
}: {
  fallback: string;
  size?: 'sm' | 'default';
}) {
  const goBack = useNavigateBack(fallback);

  return (
    <Button type="button" variant="outline" size={size} onClick={goBack}>
      <ChevronLeftIcon className={size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} />
      {t().common.back}
    </Button>
  );
}
